const locales = require('./locales.json')

/**
 * next-i18next config shared by both sides: next-i18next.config.js (read by serverSideTranslations) adds the filesystem
 * localePath, _app's appWithTranslation adds the public one. serializeConfig: false keeps this object, the locale
 * list and the server's filesystem path out of every page's __NEXT_DATA__; the client gets the config from _app.
 *
 * @type {import('next-i18next/pages').UserConfig}
 */
module.exports = {
  fallbackLng: {},
  i18n: {
    defaultLocale: 'en-GB',
    locales,
  },
  returnNull: true,
  serializeConfig: false,
}
